<div class="content">

    <div class="d-flex justify-content-center"  (click)="goToAddCustomer()" style="cursor: pointer;">
        <div class="d-flex align-items-center" style="white-space: nowrap ;">
            <i class="fa-solid fa-circle-plus fa-2x"></i>
            <span class="small span-icon" style="margin-left: 7%;">Add Customer</span>
        </div>

    </div>

    <div class="d-flex justify-content-center mt-4">
        <ng2-smart-table [settings]="settings" [source]="listCustomerView" (custom)="onCustomAction($event)">
        </ng2-smart-table>


    </div>

</div>

<ng-template #confirmEliminaCustomer let-modal>
    <div class="modal-header header-background-color">
        <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
        <div (click)="modal.close(false)">
            <i class="fa-solid fa-xmark close-modal-color"></i>
        </div>
    </div>
    <div class="modal-body">
        <p>Clicking Delete will proceed with the elimination of the customer!</p>


    </div>
    <div class="modal-footer footer-modal-background-color">
        <button class="btn btn-primary btn-lg active" (click)="modal.close(true)">Delete</button>
        <button class="btn btn-primary btn-lg active button-reset" (click)="modal.close(false)">Cancel</button>
    </div>
</ng-template>

<ng-template #updateCustomer let-modal>
    <div class="modal-header header-background-color">
        <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
        <div (click)="modal.close(false)">
            <i class="fa-solid fa-xmark close-modal-color"></i>
        </div>
    </div>
    <div class="modal-body">

        <p>Click update customer for go to update page!</p>


    </div>
    <div class="modal-footer footer-modal-background-color">
        <div class="d-flex justify-content-end mt-4">
            <button class="btn btn-primary btn-lg active btn-sm" (click)="modal.close(true)">Update Customer</button>
        </div>
    </div>

</ng-template>